export const NETWORKID = process.env.REACT_APP_NETWORKID
